// LandingAppStoreFooter.js - Delegates to GlobalFooter
import React from 'react';
import GlobalFooter from '../../../components/Footer/GlobalFooter';

const LandingAppStoreFooter = () => {
  return <GlobalFooter />;
};

export default LandingAppStoreFooter;
